module.exports = __webpack_public_path__ + "img/tabs4.f45617c0.png";